import {
  DocumentationResponse,
  OcrData,
  OcrResponseDto,
} from "./../../interfaces/Ocr";
import { URL_ENDPOINTS } from "../../constants";
import { axiosInstance as Api } from "../../utils/api-helper";

const OcrService = {
  postOcr: (ocrRequest: OcrData): Promise<OcrResponseDto> => {
    return Api.post(URL_ENDPOINTS.OCR + "/ocr", ocrRequest);
  },
  identifyDocument: (
    creditProposalId: string
  ): Promise<DocumentationResponse> => {
    return Api.post(
      URL_ENDPOINTS.CREDIT_PROPOSAL + `/${creditProposalId}/identity-documents`
    );
  },
};

export default OcrService;
